import createAsyncAction from "../../utils/asyncAction";
import * as api from "../api/survey/survey_api";
import * as types from "../constants/survey_constants";

const getUserSurveysTypes = {
  success: types.GET_USER_SURVEYS_SUCCESS,
  failure: types.GET_USER_SURVEYS_FAILURE,
};

const getSingleSurveyTypes = {
  success: types.GET_SINGLE_SURVEY_SUCCESS,
  failure: types.GET_SINGLE_SURVEY_FAILURE,
};

export const getUserSurveys = createAsyncAction(
  api.getUserSurveys,
  getUserSurveysTypes,
);

export const getSingleSurvey = createAsyncAction(
  api.getSingleSurvey,
  getSingleSurveyTypes,
);

export const submitSurveyResponse = (id, values) => async (dispatch) => {
  try {
    const response = await api.submitSurveyResponse(id, values);
    const { error, data } = response;

    if (error) {
      dispatch({
        type: types.SUBMIT_SURVEY_RESPONSE_FAILURE,
        payload: error,
      });
      return null;
    }

    dispatch({
      type: types.SUBMIT_SURVEY_RESPONSE_SUCCESS,
      payload: data,
    });

    return data?.response || null;
  } catch (error) {
    dispatch({
      type: types.SUBMIT_SURVEY_RESPONSE_FAILURE,
      payload: error.message,
    });
    return null;
  }
};
